import React from 'react';
import IntlMessages from 'util/IntlMessages';

const Footer = () => {
  const yaer = new Date().getFullYear();
  return (
    <footer className="app-footer">
      <div className="d-flex flex-row justify-content-between">
        <div>
          <span><IntlMessages id="footer.copyright" /> NinjaDev &copy; 2019 - {yaer}</span>
        </div>
        <div>
          <IntlMessages id="footer.technicalSupport" /> 063.80.98.990
        </div>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js